export default __webpack_public_path__ + "static/media/WDCM3.97a5c2c9.jpg";